import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

// Récupère la liste des types de subscription par club dans r2vel_subscription_type
// Permet d'afficher les options de subscriptionType selectionnable, puis de stocker le choix dans r2vel_product.subscription_type_id
const getSubscriptionTypes = async (velId: number) => {
  const url = `/api/abo/vel/${velId}/subscriptionType`;

  const { data } = await axiosInstance.get(url);

  return data;
}

export const useSubscriptionTypes = ({ velId }: { velId: number }) => {
  return useQuery({
    queryKey: ["subscriptionTypes", velId],
    queryFn: () => getSubscriptionTypes(velId),
    enabled: !!velId
  });
}
